import './Button.scss';
import * as React from 'react';
import classnames from 'classnames';
import { AccentColors } from 'types/accentColors';
export type Props = {
  id?: string;
  name?: string;
  title?: string;
  className?: string;
  onClick?: (a: React.MouseEvent<HTMLButtonElement>) => void;
  type?: string;
  children: React$Node;
  color?: (AccentColors | undefined | null) | 'on-dark';
  textLink?: boolean;
  undecorated?: boolean;
  disabled?: boolean;
};
export default class Button extends React.Component<Props> {
  static defaultProps = {
    textLink: false,
    color: 'accent-color-one',
    undecorated: false,
    disabled: false,
  };
  render() {
    const { children, color, textLink, undecorated, ...rest } = this.props;
    return (
      <button
        className={classnames('Button', {
          'Button--link': textLink,
          'Button--primary': !textLink,
          'Button--undecorated': undecorated,
          [`Button--${color || ''}`]: color != null && !textLink,
        })}
        {...rest}
      >
        {children}
      </button>
    );
  }
}
